module.exports = __webpack_public_path__ + "static/media/henrik.f66ccb4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/henrik.jpg
// module id = 37
// module chunks = 0